module.exports = __webpack_public_path__ + "static/media/ic_transferencias.36cd8590.svg";